import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import App from './App';
import { desktopTheme, FontsStyles, GlobalStyles, laptopTheme } from '@styles';
import { useMatchMedia } from '@utils';
import { breakpoints } from '@config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const ThemeSelector: React.FC = () => {
  const desktopMatch = useMatchMedia(breakpoints.desktop);

  return (
    <ThemeProvider theme={(desktopMatch) ? desktopTheme : laptopTheme}>
      <App />
      <FontsStyles />
      <GlobalStyles />
    </ThemeProvider>
  )
}

root.render(
  <ThemeSelector />
);
